import { useMemo } from 'react';

import { mergeClustersWithInventory } from '@cast/features-cluster-shared-utils';
import {
  useAssetListClustersQuery,
  useClusters,
} from '@cast/shared-cluster-context-data-access';
import type { UseServerData } from '@cast/shared-search-ui';
import { Cluster } from '@cast/types';
import { makeRefetchOnlyFailed } from '@cast/utils';

export const useClustersSearchData: UseServerData<Cluster> = () => {
  const {
    clusters,
    isLoading: isClustersLoading,
    error: clustersError,
    refetch: refetchClusters,
    hasError: hasClustersError,
  } = useClusters({ polling: true, withDiscovered: true });

  const {
    assetListClusters,
    isLoading: isAssetsLoading,
    error: assetsError,
    refetch: refetchAssets,
  } = useAssetListClustersQuery({ polling: true });

  const data = useMemo(
    () => mergeClustersWithInventory(clusters, assetListClusters),
    [assetListClusters, clusters]
  );

  return {
    data,
    isLoading: isClustersLoading || isAssetsLoading,
    ...makeRefetchOnlyFailed(
      [hasClustersError ? clustersError : undefined, refetchClusters],
      [assetsError, refetchAssets]
    ),
  };
};
